<template>
  <page-outline>
    <template slot="pageContent">
      <div :class="['content bg-light',{ expanded: !isSidebarOpen }]">
        <div>
          <b-container fluid>
            <!-- title -->
            <div class="content-title">
              <b-row>
                <h1>Audit Logs</h1>
              </b-row>
              <b-row>
                <span>Track all system changes and user activities</span>
              </b-row>
            </div>

            <!-- data -->
            <b-row class="stats">
              <b-col @click="stat.status != null ? selectStatus(stat.status): ''" v-for="(stat, index) in stats" v-bind:key="index">
                <div>
                  <span :style="{color: stat.color}">{{ stat.number }}</span>
                  <span>{{ stat.title }}</span>
                </div>
              </b-col>
            </b-row>
          </b-container>

          <!-- flters -->
          <div class="filters">
            <b-row class="filters-items">
              <!-- Search -->
              <b-col>
                <div class="filter-item">
                  <span class="filter-item-title">Search Logs</span>
                  <input type="text" class="filter-item-content" placeholder="Search by ID, action, summary..." @input="event => (paginationObj.search = sanitize(event.target.value), submit())"  @keyup.enter="submit()"/>
                </div>
              </b-col>

              <b-col>
                <!-- Entity Type -->
                <div class="filter-item">
                  <span class="filter-item-title text-ellipsis">Entity Type</span>
                  <a id="entity-picker-link"
                    class="filter-item-content d-flex justify-content-between py-2 px-3"
                    href="#">
                    <span class="fixed-span-size">
                      {{ this.paginationObj.entity == null ? 'All Types' : entityList.filter(item => {
                        if(item == this.paginationObj.entity){
                          return item
                        }
                    })[0]}}
                    </span>
                    <i class="fa-light fa-chevron-down" size="17px" id="action-type-chevron"></i>
                  </a>
                   <b-popover target="entity-picker-link" triggers="focus" placement="bottom" custom-class="popover">
                    <div>
                      <span v-for="(type, index) in entityList" :key="index" :class="['popover-option', {'popover-option-selected': type == 'All Types' ? paginationObj.entity == null : type == paginationObj.entity}]" @click="selectEntityType(type)">
                        {{ type }}
                      </span>
                    </div>
                  </b-popover>
                </div>
              </b-col>

              <b-col>
                <!-- Action Type -->
                <div class="filter-item">
                  <span class="filter-item-title text-ellipsis">Action Type</span>
                  <a id="action-picker-link"
                    class="filter-item-content d-flex justify-content-between py-2 px-3"
                    href="#">
                    <span class="fixed-span-size">
                      {{ this.paginationObj.action == null ? 'All Actions' : actionList.filter(item => {
                        if(item == this.paginationObj.action){
                          return item
                        }
                    })[0]}}
                    </span>
                    <i class="fa-light fa-chevron-down" size="17px" id="action-type-chevron"></i>
                  </a>
                  <b-popover target="action-picker-link" triggers="focus" placement="bottom" custom-class="popover">
                    <div>
                      <span v-for="(action, index) in actionList" :key="index" :class="['popover-option', {'popover-option-selected': action == 'All Actions' ? paginationObj.action == null : action == paginationObj.action}]" @click="selectActionType(action)">
                        {{ action }}
                      </span>
                    </div>
                  </b-popover>
                </div>
              </b-col>

              <b-col>
                <!-- Pagination -->
                <div class="filter-item">
                  <span class="filter-item-title text-ellipsis">Per Page</span>
                  <a id="pagination-picker-link"
                    class="filter-item-content d-flex justify-content-between py-2 px-3"
                    href="#">
                    <span class="fixed-span-size">{{ this.paginationObj.maxResults }}</span>
                    <i class="fa-light fa-chevron-down" size="17px" id="page-chevron"></i>
                  </a>
                  <b-popover target="pagination-picker-link" triggers="focus" placement="bottom" custom-class="popover">
                    <div>
                      <span v-for="(resultsPerPage, index) in [10,20,30,40,50]" :key="index" :class="['popover-option', {'popover-option-selected':  resultsPerPage == paginationObj.maxResults}]" @click="selectPagination(resultsPerPage)">
                        {{ resultsPerPage }}
                      </span>
                    </div>
                  </b-popover>
                </div>
              </b-col>

               <!-- Filtre date de début -->
              <b-col class="d-flex flex-row">
                <div class="filter-item" >
                  <span class="filter-item-title text-ellipsis" :title="$t('common.date_start_label')">
                    {{ $t('common.date_start_label') }}
                  </span>
                  <datetime-picker class="z-1" format="DD/MM/YYYY"
                    :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin, 'error-datepicker': dateBeginError}"
                    customInputParentClass="filter-item-content"
                    :maxLength="19"
                    :placeholderValue="$t('common.datetime_picker_empty_date')"
                    inputIcon="fa-solid fa-calendar"
                    v-model="dateBegin"
                    @input="selectBeginDate">
                  </datetime-picker>
                  <span v-if="dateBeginError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
                </div>
              </b-col>
              <!-- Filtre date de fin -->
              <b-col class="d-flex flex-row">
                <div class="filter-item" >
                  <span class="filter-item-title text-ellipsis" :title="$t('common.date_end_label')">
                    {{ $t('common.date_end_label') }}
                  </span>
                  <datetime-picker class="z-1" format="DD/MM/YYYY"
                    :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd, 'error-datepicker': dateEndError}"
                    customInputParentClass="filter-item-content"
                    customInputClass="w-100"
                    :maxLength="19"
                    :placeholderValue="$t('common.datetime_picker_empty_date')"
                    inputIcon="fa-solid fa-calendar"
                    v-model="dateEnd"
                    @input="selectEndDate">
                  </datetime-picker>
                  <span v-if="dateEndError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
                </div>
              </b-col>
            </b-row>
            <hr>
            <b-row style="display:flex; align-items:center; justify-content:space-between; padding-right:1rem;">
              <b-col>
                <span v-if="totalResultsFiltered > 0">Showing {{ paginationObj.firstIndex }} - {{
                  paginationObj.status != null || paginationObj.search != null || paginationObj.country != null ? (totalResultsFiltered < paginationObj.maxResults ? totalResultsFiltered : currentPage * paginationObj.maxResults )
                  :
                  (totalResults < paginationObj.maxResults ? totalResults : currentPage * paginationObj.maxResults )}} of {{ paginationObj.status != null || paginationObj.search != null || paginationObj.country != null ? totalResultsFiltered : totalResults }}
                  </span>
              </b-col>

              <div style="display:flex; align-items:center;  gap: 1rem;">
                <span class="selected" v-if="selectedItems.length > 0">{{ selectedItems.length }} selected</span>

                <button @click="clearSelection()" class="clear" v-if="selectedItems.length > 0"><i class="fa-classic fa-xmark"></i>Clear</button>

                <button @click="exportSelected()" v-if="selectedItems.length > 0"  class="btn-outline btn-tertiary"><i class="fa-classic fa-arrow-down-to-line"></i>Export Selected ({{ selectedItems.length }})</button>

                <button @click="exportFiltered()" class="btn-outline button-primary"><i class="fa-classic fa-arrow-down-to-line"></i>Export Filtered</button>

                <button @click="exportAll()" class="btn-outline button-primary"><i class="fa-classic fa-arrow-down-to-line"></i>Export All</button>

                <button @click="refresh()" class="btn-outline btn-dark">
                  <i :class="['fa-classic', 'fa-arrows-rotate', { 'rotate': isLoading }]"></i>
                  Refresh
                </button>
              </div>
            </b-row>
          </div>

          <!-- VIBANs list -->
          <div v-if="items != null" class="card">
            <div class="p-6">
              <h2>Audit Trail</h2>
              <span>{{ totalResults }} log entries</span>
            </div>
            <hr>
            <div v-if="totalResultsFiltered > 0" style="overflow-x:auto">
              <b-table responsive
                class="table-header-border"
                style="margin-bottom:0;"
                :items="items"
                :fields="fields"
                primary-key="id"
              >
              
                <template #head(checkbox)>
                  <label class="custom-checkbox">
                    <input type="checkbox" 
                      id="all" 
                      name="checkAll"
                      @change="selectAll($event)" />
                    <span class="checkmark"></span>
                  </label>
                </template>

                <template #cell(checkbox)="data">
                  <label class="custom-checkbox">
                    <input type="checkbox"
                          :value="data.item"
                          @change="toggleSelection($event, data.item)" />
                    <span class="checkmark"></span>
                  </label>
                </template>

                <template #cell(date)="data">
                  <div v-if="data.item.CreationDate != ''">{{isoToDDMMYYYY(data.item.CreationDate)}}</div>
                  <span style="color: #6a7282; font-size: 0.9rem;" v-if="data.item.CreationDate !== ''">{{new Date(Date.parse(data.item.CreationDate )).toLocaleTimeString("it-IT")}}</span>
                  <span v-else >—</span>
                </template>

                <template #cell(status)="data">
                  <button style="cursor: default;" v-if="data.item.Status == 0" :style="{color:'#008236','background-color':'#f0fdf4','border-color':'#b9f8cf'}" class="btn-tertiary-full">Available</button>
                  <button style="cursor: default;" v-else-if="data.item.Status == 1" class="btn-tertiary-full">Assigned</button>
                  <button style="cursor: default;" v-else class="btn-tertiary-full" :style="{color:'#c10007','background-color':'#fef2f2','border-color':'#ffc9c9'}">Frozen</button>
                </template>

                <template #cell(clientnumber)="data">
                  <span v-if="data.item.Reference1 != ''">{{ data.item.Reference1 }}</span>
                  <span v-else style="font-weight: normal;">—</span>
                </template>

                <template #cell(allocationdate)="data">
                  <div v-if="data.item.Date != ''">{{new Date(Date.parse(data.item.Date )).toLocaleDateString("fr")}}</div>
                  <span style="color: #6a7282; font-size: 0.9rem;" v-if="data.item.Date != ''">{{new Date(Date.parse(data.item.Date )).toLocaleTimeString("it-IT")}}</span>
                  <span v-else >—</span>
                </template>

                <template #cell(actions)="data">
                  <button :id="`view-transaction-btn-${data.index}`" @click="navigate('/transactionledger/'+data.item.VIBAN)" class="btn-outline-light">
                    <i class="fa-regular fa-eye"></i>
                  </button>
                  <b-popover
                    :target="`view-transaction-btn-${data.index}`"
                    triggers="hover"
                    placement="top"
                    custom-class="popover-btn"
                  >
                    View transaction
                  </b-popover>
                </template>

              </b-table>
              <hr>
            </div>
            <b-row v-if="totalResultsFiltered > 0" class="pagination">
              
              <button @click="currentPage > 1 && previous()" :class="['btn-outline-light btn', {inactive: currentPage == 1}]">Previous</button>
              <span>Page {{ currentPage }} of {{ totalPages }}</span>
              <button @click="currentPage < totalPages && next()" :class="['btn-outline-light btn', {inactive: currentPage == totalPages}]">Next</button>
            </b-row>
            <div v-else style="margin: 1rem; color: #969696; display: flex; justify-content: center;">
              <span>No results found</span>
            </div>
          </div>
          <div v-else class="card empty">
            <b-spinner label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </template>
  </page-outline>
</template>

<script>
import DateTimePicker from '@/components/common/dateTimePicker.vue';
import PageOutline from '@/components/common/PageOutline.vue'

export default {
  name: 'AuditLogsPage',
  components: {
    'page-outline': PageOutline,
    'datetime-picker': DateTimePicker,
  },
  data () {
    return {
      isSidebarOpen: true,
      items: null,
      stats: [
        {
          "title":"Total Actions",
          "number": 0,
          "color": "#2b7fff",
          "status": "all"
        },
        {
          "title":"Today's Action",
          "number": 0,
          "color": "#009966",
          "status": 'need'
        },
        {
          "title":"Creates",
          "number": 0,
          "color": "#009966",
          "status": 'pending'
        },

        {
          "title":"Updates",
          "number": 0,
          "color": "#e7000b",
          "status": 'clear'
        },
      ],
      fields: [
        { key: 'checkbox', thClass: 'text-center align-middle border-bottom', tdClass: 'text-center align-middle'},
        { key: 'date', label: 'Timestamp', thClass: 'text-left align-middle border-bottom', tdClass: 'align-middle text-left'},
        { key: 'entity', label: 'Entity Type', thClass: 'text-left align-middle border-bottom', tdClass: 'align-middle text-left'},
        { key: 'action', label: 'Action', thClass: 'text-left align-middle border-bottom', tdClass: 'align-middle text-left font-weight-bold'},
        { key: 'entityId', label: 'Entity ID', thClass: 'text-left align-middle border-bottom', tdClass: 'align-middle text-left'},
        { key: 'performedBy', label: 'Performed By', thClass: 'text-left align-middle border-bottom', tdClass: 'align-middle text-left font-weight-bold'},
        { key: 'summary', label: 'Summary', thClass: 'text-left align-middle border-bottom text-nowrap', tdClass: 'align-middle text-left'},
        { key: 'actions', label: 'Actions', thClass: 'text-center align-middle border-bottom', tdClass: 'text-center align-middle' }
      ],
      entityList: ['All Types', 'Orders', 'Payments', 'Reconciliations','VIBANs', 'Refunds', 'Imports', 'Automatch Runs', 'Users', 'Configuration', 'Accounting Events'],
      actionList: ['All Actions', 'Created', 'Updated', 'Deleted', 'Reconciled', 'Imported', 'Refund'],
      paginationObj: {
        firstIndex: 1,
        maxResults : 10,
        search : null,
        DateBegin : null,
        DateEnd : null,
        entity: null,
        action: null
      },
      currentPage: 1,
      totalPages: 0,
      selectedItems: [],
      isLoading: false,
      totalResults: null,
      totalResultsFiltered: null,
      dateBegin: '',
      dateBeginError: false,
      dateEnd: '',
      dateEndError: false,
    }
  },
  created () {
    this.$engine.services.payments.getTransactions(this.paginationObj)
    .then(resp => {
      const data = resp.data
      this.items = data.Transactions
      this.totalResultsFiltered = 10
      // this.totalResults = data.nbTotalResults

      // this.stats[0].number = data.TotalDebit
      // this.stats[1].number = data.TotalCredit
      // this.stats[2].number = data.NbPayments
      // this.stats[3].number = data.NbOrders
      // this.stats[4].number = data.NbReconcilied
      // this.stats[5].number = data.NbPending

      // this.totalPages = Math.ceil(data.nbTotalResults/this.paginationObj.maxResults)
      // this.currentPage = (this.paginationObj.firstIndex -1) / this.paginationObj.maxResults + 1
    })
    .catch(err => {
      console.log(err)
    })
  },
  methods: {
    previous (){
      this.paginationObj.firstIndex = this.paginationObj.firstIndex - this.paginationObj.maxResults
      this.currentPage--
      // this.$engine.services.payments.getGroups(this.paginationObj)
      // .then(resp => {
      //   const data = resp.data
      //   this.items = data.references;
      // })
      // .catch(err => {
      //   console.log(err)
      // })
    },
    next (){
      this.paginationObj.firstIndex = this.paginationObj.firstIndex + this.paginationObj.maxResults
      this.currentPage++
      // this.$engine.services.payments.getGroups(this.paginationObj)
      // .then(resp => {
      //   const data = resp.data
      //   this.items = data.references;
      // })
      // .catch(err => {
      //   console.log(err)
      // })
    },
    submit (){
      this.paginationObj.firstIndex = 1;
      this.currentPage = 1;

      // this.$engine.services.payments.getGroups(this.paginationObj)
      // .then(resp => {
      //   const data = resp.data
      //   this.items = data.references
      //   this.totalResults = data.nbTotalResults
      //   this.totalResultsFiltered = data.nbTotalResultsFiltered
      //   this.totalVibanAvailable = data.nbVibanFree
      //   this.totalVibanAssigned = data.nbVibanAssigned

      //   const total = this.totalResults
      //   const totalAvailable = this.totalVibanAvailable
      //   const totalAssigned = this.totalVibanAssigned
      //   const totalFrozen = total - totalAvailable - totalAssigned

      //   this.stats[0].number = total
      //   this.stats[1].number = totalAvailable
      //   this.stats[2].number = totalAssigned
      //   this.stats[3].number = totalFrozen
      //   this.stats[4].number = Math.round((totalAssigned * 100) / total) + '%'

      //   this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
      //   this.currentPage = (this.paginationObj.firstIndex -1) / this.paginationObj.maxResults + 1
      // })
      // .catch(err => {
      //   console.log(err)
      // })
    },
    toggleSelection (event, value) {
      const checked = event.target.checked;

      if (checked) {
        if (!this.selectedItems.some(item => item.VIBAN == value.VIBAN)) {
          this.selectedItems.push(value)
        }
      } else {
        const checkbox = document.querySelectorAll('input[type="checkbox"]')[0]
        if(checkbox.checked){
          checkbox.checked = false
        }
        this.selectedItems = this.selectedItems.filter(item => item.VIBAN !== value.VIBAN);
      }
    },
    selectAll (event){
      const checked = event.target.checked;
      const checkboxes = document.querySelectorAll('input[type="checkbox"]')
      if (checked) {
        checkboxes.forEach(item => item.checked = true)
        this.selectedItems = [...this.items];
      } else {
        this.selectedItems = []
        checkboxes.forEach(item => item.checked = false)
      }
    },
    clearSelection () {
      this.selectedItems = []
      const checkboxes = document.querySelectorAll('input[type="checkbox"]')
      checkboxes.forEach(item => item.checked = false)
    },
    selectEntityType (entity){
      this.paginationObj.entity = entity == "All Types" ? null : entity
      this.submit()
    },
    selectActionType (action){
      this.paginationObj.action = action == "All Actions" ? null : action
      this.submit()
    },
    selectPagination (resultsPerPage){
      this.paginationObj.maxResults = resultsPerPage
      this.paginationObj.firstIndex = 1

      // this.$engine.services.payments.getGroups(this.paginationObj)
      // .then(resp => {
      //   const data = resp.data
      //   this.items = data.references
      //   this.totalResultsFiltered = data.nbTotalResultsFiltered
      //   this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
      //   this.currentPage = (this.paginationObj.firstIndex -1) / this.paginationObj.maxResults + 1
      //   document.activeElement?.blur()
      // })
      // .catch(err => {
      //   console.log(err)
      // })
    },
    selectBeginDate (date){
      if(!date){
        this.paginationObj.DateBegin = null
        this.submit()
        return
      }
      this.paginationObj.firstIndex = 1
      this.paginationObj.DateBegin = this.formatDate(date)

      // this.$engine.services.payments.getTransactions(this.paginationObj)
      // .then(resp => {
      //   this.items = resp.data.Transactions
      //   this.totalPages = Math.ceil(resp.data.nbTotalResults/this.paginationObj.maxResults)
      // })
      // .catch(err => {
      //   console.log(err)
      // })
    },
    selectEndDate (date){
      if(!date){
        this.paginationObj.DateEnd = null
        this.submit()
        return
      }
      this.paginationObj.firstIndex = 1
      this.paginationObj.DateEnd = this.formatDate(date)

      // this.$engine.services.payments.getTransactions(this.paginationObj)
      // .then(resp => {
      //   this.items = resp.data.Transactions
      //   this.totalPages = Math.ceil(resp.data.nbTotalResults/this.paginationObj.maxResults)
      // })
      // .catch(err => {
      //   console.log(err)
      // })
    },
    formatDate (dateStr) {
      const [day, month, year] = dateStr.split("/");
      return `${year}-${month}-${day}`;
    },
    isoToDDMMYYYY (isoDate) {
      const [year, month, day] = isoDate.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
    exportCSV (filters){
      // this.$engine.services.payments.getGroups(filters)
      // .then(resp => {
      //   const vibanData = resp
      //   let firstLine = 'Virtual IBAN' + ';' +
      //     'Country' + ';' +
      //     'Status' + ';' +
      //     'Client Number' + ';' +
      //     'Allocation Date' + ';' +
      //     'Total Volume' + '\r\n'

      //   let line = ''

      //   vibanData.data.references.forEach(item => {
      //     line += item.VIBAN + ';' +
      //     item.VIBAN.slice(0,2) + ';' + (item.Status == 0 ? 'Available' : item.Status == 1 ? 'Assigned' : 'Frozen') + ';' + item.Reference1 + ';' + (item.Date != "" ? new Date(Date.parse(item.Date )).toLocaleDateString("fr") : ' ' )  + ';' + item.Amount.toFixed(2)+ '\r\n'
      //   })

      //   let data = firstLine + line
      //   let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      //   let downloadLink = document.createElement('a')
      //   let today = moment()
      //   let fileName = 'vibans_' + today.unix() + '.csv'

      //   downloadLink.href = linkSource
      //   downloadLink.download = fileName
      //   downloadLink.click()
      //   this.isAlertOpen = true;
      //   this.countExported = vibanData.data.references.length
      //   setTimeout(()=>{
      //     this.isAlertOpen = false;
      //     this.countExported = 0
      //   }, 3000)
      // })
      // .catch(err => {
      //   console.log(err)
      // })
    },
    exportAll () {
      this.exportCSV({})
    },
    exportFiltered () {
      this.exportCSV({
        firstIndex: 1,
        search : this.paginationObj.search,
        entity: this.paginationObj.entity,
        action : this.paginationObj.action,
      })
    },
    exportSelected (){
      const selection = [...this.selectedItems];
      // let firstLine = 'Virtual IBAN' + ';' +
      //   'Country' + ';' +
      //   'Status' + ';' +
      //   'Client Number' + ';' +
      //   'Allocation Date' + ';' +
      //   'Total Volume' + '\r\n'

      // let line = ''

      // selection.forEach(item => {
      //   line += item.VIBAN + ';' +
      //   item.VIBAN.slice(0,2) + ';' + (item.Status == 0 ? 'Available' : item.Status == 1 ? 'Assigned' : 'Frozen') + ';' + item.Reference1 + ';' + (item.Date != "" ? new Date(Date.parse(item.Date )).toLocaleDateString("fr") : ' ' )  + ';' + item.Amount.toFixed(2)+ '\r\n'
      // })

      // let data = firstLine + line
      // let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      // let downloadLink = document.createElement('a')
      // let today = moment()
      // let fileName = 'vibans_' + today.unix() + '.csv'

      // downloadLink.href = linkSource
      // downloadLink.download = fileName
      // downloadLink.click()
      // this.isAlertOpen = true;
      // this.countExported = selection.length
      // setTimeout(()=>{
      //   this.isAlertOpen = false;
      //   this.countExported = 0
      // }, 3000)
    },
    refresh (){
      if (this.isLoading) return;
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        this.paginationObj = {
          firstIndex: 1,
          maxResults : 10,
          search : null,
          entity: null,
          action : null,
        };
        this.submit()
      }, 800);
    },
  }
}
</script>

<style scoped>
.stats>div{
  display: flex;
}

.stats{
  display: flex;
  gap: 1rem;
  padding: 1rem 0rem;
}


.stats>div{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 8rem;
  background-color: #fff;
  border: 1px solid #0000001a;
  border-radius: calc(1rem - 2px);
  padding: 0rem 1rem;
}

.stats>div:hover{
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  cursor: pointer;
}

.stats>div>div{
  display: grid;
  row-gap: 1.5rem;
  color: #000000a6;
}

.stats>div>div>span:last-of-type{
  font-size: 1rem;
}

.stats>div>div>span{
  font-size: 2rem;
  display: flex;
  justify-content: center;
}
</style>
